const apiKey = process.env.REACT_APP_API_KEY;
export default apiKey;
